import { takeEvery, takeLatest } from 'redux-saga/effects'

import { AgencyPartnersActionTypes } from './partners/link-agency/types'
import * as AgencyPartnersSagas from './partners/link-agency/sagas'

import { AgreementActionTypes } from './partners/agreement/types'
import * as AgreementSagas from './partners/agreement/sagas'

import { AgreementOfferActionTypes } from './partners/agreementsOffer/types'
import * as AgreementOfferSagas from './partners/agreementsOffer/sagas'

import { AirActionTypes } from './air/types'
import * as AirSagas from './air/sagas'

import { ApprovalsActionTypes } from './approvals/types'
import * as ApprovalsSagas from './approvals/sagas'

import { AuditsActionTypes } from './audits/types'
import * as AuditsSagas from './audits/sagas'

import { AuthActionTypes } from './auth/types'
import * as AuthSagas from './auth/sagas'

import { BedroomsActionTypes } from './partners/bedrooms/types'
import * as BedroomsSagas from './partners/bedrooms/sagas'

import { BedroomsOfferActionTypes } from './partners/offer/types'
import * as BedroomsOfferSagas from './partners/offer/sagas'

import { CitiesActionTypes } from './cities/types'
import * as CitiesSagas from './cities/sagas'

import { ClosingsActionTypes } from './closings/types'
import * as ClosingsSagas from './closings/sagas'

import { ConferencesActionTypes } from './conferences/types'
import * as ConferencesSagas from './conferences/sagas'

import { GroupTreesActionTypes } from './groupTrees/types'
import * as GroupTreesSagas from './groupTrees/sagas'

import { HotelsActionTypes } from './hotels/types'
import * as HotelsSagas from './hotels/sagas'

import { IssuancesActionTypes } from './issuances/types'
import * as IssuancesSagas from './issuances/sagas'

import { MeActionTypes } from './me/types'
import * as MeSagas from './me/sagas'

import { OrganizationsActionTypes } from './organizations/types'
import * as OrganizationsSagas from './organizations/sagas'

import { PartnerHotelActionTypes } from './partners/hotels/types'
import * as PartnerHotelsSagas from './partners/hotels/sagas'

import { PartnersActionTypes } from './partners/types'
import * as PartnersSagas from './partners/sagas'

import { RequestsActionTypes } from './requests/types'
import * as RequestsSagas from './requests/sagas'

import { ResourcesActionTypes } from './resources/types'
import * as ResourcesSagas from './resources/sagas'

import { TreeActionTypes } from './tree/types'
import * as TreeSagas from './tree/sagas'

import { UsersActionTypes } from './users/types'
import * as UsersSagas from './users/sagas'

import { VehiclesActionTypes } from './vehicles/types'
import * as VehiclesSagas from './vehicles/sagas'

export default [
  takeEvery(AirActionTypes.GET_AIR, AirSagas.getAir),
  takeEvery(HotelsActionTypes.GET_HOTELS, HotelsSagas.getHotels),
  takeEvery(
    OrganizationsActionTypes.GET_ORGANIZATIONS,
    OrganizationsSagas.getOrganizations
  ),
  takeEvery(
    RequestsActionTypes.SAVE_REQUEST_TICKETS,
    RequestsSagas.saveRequestTickets
  ),
  takeEvery(ResourcesActionTypes.GET_RESOURCES, ResourcesSagas.getResources),
  takeLatest(
    AgencyPartnersActionTypes.GET_AGENCY_PARTNERS,
    AgencyPartnersSagas.getAgencyPartners
  ),
  takeLatest(
    AgencyPartnersActionTypes.SEND_AGENCY_PARTNERS,
    AgencyPartnersSagas.sendAgencyPartners
  ),
  takeLatest(AgreementActionTypes.GET_AGREEMENT, AgreementSagas.getAgreement),
  takeLatest(AgreementActionTypes.SEND_AGREEMENT, AgreementSagas.sendAgreement),
  takeLatest(
    AgreementOfferActionTypes.SEND_AGREEMENT_OFFER,
    AgreementOfferSagas.sendAgreementOffer
  ),
  takeLatest(AirActionTypes.GET_AIR_HISTORY, AirSagas.getAirHistory),
  takeLatest(AirActionTypes.GET_AIRPORTS, AirSagas.getAirports),
  takeLatest(ApprovalsActionTypes.GET_APPROVALS, ApprovalsSagas.getApprovals),
  takeLatest(
    ApprovalsActionTypes.SET_APPROVAL_STATUS,
    ApprovalsSagas.setApprovalStatus
  ),
  takeLatest(AuditsActionTypes.GET_AUDITS, AuditsSagas.getAudits),
  takeLatest(AuthActionTypes.AUTH_BY_QR_CODE, AuthSagas.authByQRCode),
  takeLatest(AuthActionTypes.AUTH_BY_USERNAME, AuthSagas.authByUsername),
  takeLatest(
    AuthActionTypes.AUTH_FORGOT_PASSWORD,
    AuthSagas.authForgotPassword
  ),
  takeLatest(BedroomsActionTypes.GET_BEDROOMS, BedroomsSagas.getBedrooms),
  takeLatest(BedroomsActionTypes.SEND_BEDROOMS, BedroomsSagas.sendBedrooms),
  takeLatest(
    BedroomsOfferActionTypes.GET_BEDROOMS_OFFER,
    BedroomsOfferSagas.getBedroomsOffer
  ),
  takeLatest(
    BedroomsOfferActionTypes.SEND_BEDROOMS_OFFER,
    BedroomsOfferSagas.sendBedroomsOffer
  ),
  takeLatest(CitiesActionTypes.GET_CITIES, CitiesSagas.getCities),
  takeLatest(ClosingsActionTypes.GET_CLOSINGS, ClosingsSagas.getClosings),
  takeLatest(
    ClosingsActionTypes.SET_CLOSING_STATUS,
    ClosingsSagas.setClosingStatus
  ),
  takeLatest(
    ConferencesActionTypes.GET_CONFERENCES,
    ConferencesSagas.getConferences
  ),
  takeLatest(
    ConferencesActionTypes.SET_CONFERENCE_STATUS,
    ConferencesSagas.setConferenceStatus
  ),
  takeLatest(
    GroupTreesActionTypes.GET_GROUP_TREES,
    GroupTreesSagas.getGroupTrees
  ),
  takeLatest(
    GroupTreesActionTypes.SEND_GROUP_TREES,
    GroupTreesSagas.sendGroupTrees
  ),
  takeLatest(
    HotelsActionTypes.GET_HOTELS_HISTORY,
    HotelsSagas.getHotelsHistory
  ),
  takeLatest(IssuancesActionTypes.GET_ISSUANCES, IssuancesSagas.getIssuances),
  takeLatest(IssuancesActionTypes.SEND_ISSUANCE, IssuancesSagas.sendIssuance),
  takeLatest(MeActionTypes.CHANGE_PASSWORD, MeSagas.changePassword),
  takeLatest(MeActionTypes.GENERATE_QRCODE, MeSagas.generateQRCode),
  takeLatest(MeActionTypes.GET_ME, MeSagas.getMe),
  takeLatest(MeActionTypes.GET_ORGANIZATION, MeSagas.getOrganization),
  takeLatest(MeActionTypes.GET_POLICY, MeSagas.getPolicy),
  takeLatest(
    PartnerHotelActionTypes.GET_PARTNER_HOTELS,
    PartnerHotelsSagas.getPartnerHotels
  ),
  takeLatest(
    PartnerHotelActionTypes.SEND_PARTNER_HOTEL,
    PartnerHotelsSagas.sendPartnerHotel
  ),
  takeLatest(PartnersActionTypes.GET_PARTNERS, PartnersSagas.getPartners),
  takeLatest(PartnersActionTypes.SEND_PARTNER, PartnersSagas.sendPartner),
  takeLatest(
    RequestsActionTypes.GET_FULL_REQUEST,
    RequestsSagas.getFullRequest
  ),
  takeLatest(RequestsActionTypes.GET_MY_REQUESTS, RequestsSagas.getMyRequests),
  takeLatest(
    RequestsActionTypes.SAVE_FULL_REQUEST,
    RequestsSagas.saveFullRequest
  ),
  takeLatest(
    RequestsActionTypes.SAVE_REQUEST_ITINERARY,
    RequestsSagas.saveRequestItinerary
  ),
  takeLatest(
    RequestsActionTypes.SAVE_REQUEST_STANDARD_ASSIGNMENTS,
    RequestsSagas.saveRequestStandardAssignments
  ),
  takeLatest(
    RequestsActionTypes.SET_UNDERWAY_STATUS,
    RequestsSagas.setUnderwayStatus
  ),
  takeLatest(
    ResourcesActionTypes.RELOAD_RESOURCES_PAGE,
    ResourcesSagas.reloadResourcesPage
  ),
  takeLatest(ResourcesActionTypes.SET_RESOURCES, ResourcesSagas.setResources),
  takeLatest(TreeActionTypes.GET_TREE, TreeSagas.getTree),
  takeLatest(UsersActionTypes.GET_USERS, UsersSagas.getUsers),
  takeLatest(
    VehiclesActionTypes.GET_VEHICLES_HISTORY,
    VehiclesSagas.getVehiclesHistory
  ),
  takeLatest(VehiclesActionTypes.GET_VEHICLES, VehiclesSagas.getVehicles)
]
